import { isRuntimeVerbose } from './runtimeNoisePolicy';

declare global {
  interface Window { SNAP_DEBUG?: boolean }
}

try {
  if (typeof console !== 'undefined' && !isRuntimeVerbose()) {
    const noop = () => undefined;
    console.debug = noop;
    console.log = noop;
    console.info = noop;
    console.warn = noop;
  }
} catch {
  // ignore
}

